import { render, staticRenderFns } from "./OrdersNew.vue?vue&type=template&id=42d9e931"
import script from "./OrdersNew.vue?vue&type=script&lang=js"
export * from "./OrdersNew.vue?vue&type=script&lang=js"
import style0 from "./OrdersNew.vue?vue&type=style&index=0&id=42d9e931&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports